// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1GZv1","signatureBlock":"Footer_signatureBlock__ayKQM","signature":"Footer_signature__1nDYv"};